import { takeEvery, put, call } from 'redux-saga/effects'
import store from '../../store'
import {
  GET_FIELD_OF_WORK,
  GET_E_INVOICE_OPERATORS,
  LOAD_PROFILE_START,
  UPDATE_PROFILE
} from '../../constants/employer'
import { API_SERVER } from '../../constants'
import { apiManualRequest, apiManualPost } from '../../utils/employer/request'
import {
  getFieldOfWorkSuccess,
  getOperatorsEinvoiceSuccess,
  getOperatorsEinvoiceFailed,
  loadProfileSuccess,
  loadProfileFailed,
  updateProfileSuccess,
  updateProfileFailed
} from '../../actions/employer'
import { propertyArray } from '../../utils/invoice.utils'
import { updateFormValues } from '../../form'

// loadProfileSaga
function* loadProfileSaga({ data }) {
  const selectedUser = data
  try {
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    if (!!uuid) {
      const url = `${API_SERVER}/GetEmployerDetails`

      const body = JSON.stringify({
        uuid: userType == 2 ? selectedUser.uuid : uuid
      })
      const result = yield call(apiManualPost, url, body)
      const resultParsed = JSON.parse(result.data)

      const formData = { ...resultParsed }
      formData.conmpanyName = resultParsed.company_name
      formData.contactName = resultParsed.contact_name
      formData.companyEmail = resultParsed.email
      formData.phoneNumber = resultParsed.phone_number
      formData.e_invoice_address = resultParsed.einvoice_address
      formData.businessID = resultParsed.business_id
      formData.e_invoice_operator = resultParsed.einvoice_operator
      formData.zipCode = resultParsed.zip_code

      for (const [key, value] of Object.entries(formData)) {
        if (value === null) {
          formData[key] = ''
        }
      }

      yield put(loadProfileSuccess(resultParsed))
      yield put(updateFormValues('companyProfile', formData))
    }
  } catch (e) {
    yield put(loadProfileFailed(e))
  }
}

// updateProfileSaga
function* updateProfileSaga({ formValues }) {
  try {
    const uuid = store.getState().client.user.data[2]

    // const userType = store.getState().client.user.data[4]
    // const { adminUser } = store.getState()
    // const { selectedUser } = adminUser

    // const userInfor = store.getState().companyProfile.userData
    const url = `${API_SERVER}/UpdateEmployerDetails`

    const formBody = {
      // uuid: userType == 2 ? selectedUser.uuid : uuid,
      uuid: uuid,
      contactname: formValues.contactName,
      phonenumber: formValues.phoneNumber,
      fieldwork: formValues.field_work,
      address: formValues.address,
      city: formValues.city,
      zipcode: formValues.zipCode,
      country: formValues.country,
      billingmethod: formValues.billing_method,
      einvoiceaddress: formValues.e_invoice_address,
      einvoiceoperator: formValues.e_invoice_operator
    }

    const body = {
      // ...userInfor,
      ...formBody
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))

    if (
      result.data ===
      'Employer company details information updated successfully!'
    ) {
      let getUrl = `${API_SERVER}/GetEmployerDetails`
      let getBoby = JSON.stringify({
        // uuid: userType == 2 ? selectedUser.uuid : uuid
        uuid: uuid
      })
      let getResult = yield call(apiManualPost, getUrl, getBoby)
      let getResultParsed = JSON.parse(getResult.data)
      yield put(updateProfileSuccess(getResultParsed))
    } else {
      yield put(updateProfileFailed())
    }
  } catch {
    yield put(updateProfileFailed())
  }
}

function* getFieldOfWorkSaga() {
  try {
    const url = `${API_SERVER}/GetEmployerFieldOfWork`
    const result = yield apiManualRequest(url)
    yield put(getFieldOfWorkSuccess(result.data))
  } catch (error) {}
}

function* getEinvoiceOperatorsSaga() {
  try {
    const url = `${API_SERVER}/GetFinInvoiceOperators`
    const result = yield apiManualRequest(url)
    const parRes = JSON.parse(result.data)
    const parsedResult = propertyArray(parRes, 'operator_name')
    if (parsedResult) yield put(getOperatorsEinvoiceSuccess(parsedResult))
  } catch (error) {
    getOperatorsEinvoiceFailed(error)
  }
}

export function* watchLoadProfileSaga() {
  yield takeEvery(LOAD_PROFILE_START, loadProfileSaga)
}

export function* watchUpdateProfileSaga() {
  yield takeEvery(UPDATE_PROFILE, updateProfileSaga)
}

export function* watchGetFieldOfWork() {
  yield takeEvery(GET_FIELD_OF_WORK, getFieldOfWorkSaga)
}

export function* watchGetEinvoiceOperatorsSaga() {
  yield takeEvery(GET_E_INVOICE_OPERATORS, getEinvoiceOperatorsSaga)
}
